import TextField from '@material-ui/core/TextField';

export function TextInput(props: React.ComponentProps<typeof TextField>) {
  const {
    id,
    autoFocus = false,
    className,
    disabled = false,
    InputProps,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    onKeyPress,
    placeholder,
    style,
    type,
    value,
    error,
    helperText,
  } = props;
  return (
    <TextField
      id={id}
      autoFocus={autoFocus}
      disabled={disabled}
      fullWidth
      inputProps={{
        className: className,
        style: {
          color: 'rgba(0, 0, 0)',
          padding: InputProps?.startAdornment
            ? '13px 20px 13px 0'
            : '13px 20px',
          textOverflow: 'ellipsis',
        },
      }}
      InputProps={InputProps}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      style={{
        backgroundColor: 'var(--color-white)',
        ...style,
      }}
      type={type}
      value={value}
      variant="outlined"
      error={error}
      helperText={helperText}
    />
  );
}
